import GPimage from "../images/gpInteligence.svg";
import ProgressHome from "./StepSlider/ProgressHome";
import "./HomePage.css";
import { useEffect, useState } from "react";


const HomePage = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const simulateProgress = () => {
      // Simular progreso del 25%
      setProgress(25);
      setTimeout(() => {
        // Simular progreso del 50%
        setProgress(50);
        setTimeout(() => {
          // Simular progreso del 75%
          setProgress(75);
          setTimeout(() => {
            // Simular progreso del 100%
            setProgress(100);
          }, 1000);
        }, 1000);
      }, 2000);
    };

    simulateProgress();
  }, []);


  return (
    <>
        <div className="contain-logo">
        <img src={GPimage} alt="gpImage" style={{ marginBottom:'300px', width: "200px" }}/>
        <ProgressHome value={progress}/>
      </div>
    </>
  );
};

export default HomePage;
